import { c as _c } from "react/compiler-runtime";
import { CRM_BASE_API, CRM_PIPELINE_API } from 'modules/crm/api/crm-pipeline-api';
import { ReassignContactStageProps } from 'modules/crm/pipeline/type/pipeline-contact-interface';
import { PipelineInterface, PipelineUpdateInterface, StageContactInterface } from 'modules/crm/types/pipeline-interface';
import { MutableRefObject } from 'react';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { getStageRevalidationKey } from '../utils/get-stage-revalidation-key';
import { StageMutateType } from '../type/stage-mutate-type';
export const usePipelineActions = (pipelineId, stageMutatesRef) => {
  const $ = _c(17);
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher,
    isFetching
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.post
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] !== pipelineId || $[3] !== postFetcher) {
    t2 = async t3 => {
      const {
        stageId,
        contactId
      } = t3;
      await postFetcher(`${CRM_BASE_API}/contacts/${contactId}/pipelines/${pipelineId}/stage`, {
        stageId
      });
    };
    $[2] = pipelineId;
    $[3] = postFetcher;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const reassignContactStage = t2;
  const addContactToStage = _temp;
  const removeContactFromStage = _temp2;
  let t3;
  if ($[5] !== reassignContactStage || $[6] !== revalidateModules || $[7] !== stageMutatesRef) {
    t3 = async (currStageId, nextStageId, contact_1) => {
      const fromStage = stageMutatesRef?.current[currStageId];
      const toStage = stageMutatesRef?.current[nextStageId];
      if (fromStage && toStage) {
        ;
        try {
          await toStage(data_3 => addContactToStage(data_3, contact_1), {
            revalidate: false
          });
          await fromStage(data_4 => removeContactFromStage(data_4, contact_1), {
            revalidate: false
          });
          await reassignContactStage({
            stageId: Number(nextStageId),
            contactId: Number(contact_1.id)
          });
          await Promise.all([revalidateModules([getStageRevalidationKey(currStageId)]), revalidateModules([getStageRevalidationKey(nextStageId)])]);
        } catch (t4) {
          await fromStage(data_1 => addContactToStage(data_1, contact_1), {
            revalidate: false
          });
          await toStage(data_2 => removeContactFromStage(data_2, contact_1), {
            revalidate: false
          });
        }
      }
    };
    $[5] = reassignContactStage;
    $[6] = revalidateModules;
    $[7] = stageMutatesRef;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const updateDnDStages = t3;
  let t4;
  if ($[9] !== fetcher || $[10] !== pipelineId) {
    t4 = data_5 => fetcher(`${CRM_PIPELINE_API}/${pipelineId}`, data_5);
    $[9] = fetcher;
    $[10] = pipelineId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== isFetching || $[13] !== reassignContactStage || $[14] !== t4 || $[15] !== updateDnDStages) {
    t5 = {
      updatePipeline: t4,
      reassignContactStage,
      updateDnDStages,
      isFetching
    };
    $[12] = isFetching;
    $[13] = reassignContactStage;
    $[14] = t4;
    $[15] = updateDnDStages;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
function _temp(data, contact) {
  return data && data.map((item, index) => ({
    ...item,
    items: index === 0 ? [contact, ...item.items] : item.items
  }));
}
function _temp2(data_0, contact_0) {
  return data_0 && data_0.map(item_0 => ({
    ...item_0,
    items: item_0.items.filter(item_1 => item_1.id !== contact_0.id)
  }));
}